<template>
  <div>
    <div class="design_box_out">
      <div class="tool_company design_box banner-product">
        <img :src="property.pic[0].url" alt="" style="width: 100%;display: block;" v-if="property.pic[0]">
        <img src="https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png" alt="" style="width: 100%;display: block;" v-else>
        <p class="product_swiper_crole"><span></span><span></span><span></span></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  },
  created() {
	  console.log(this.property,"this.property21===---====-----*****")
  }
};
</script>



